import { useState } from 'react';

const faqs = [
  {
    q: '无极电影网的影片需要付费观看吗？',
    a: '完全免费！无极电影网始终坚持免费观影理念，所有影片资源均无需付费或会员订阅即可在线观看。我们通过广告合作维持运营，确保每一位影迷都能零门槛享受高清电影。',
  },
  {
    q: '播放影片时出现卡顿或缓冲怎么办？',
    a: '无极电影网采用先进的极速播放引擎和多线CDN加速技术，正常情况下蓝光画质也能流畅播放。如遇卡顿，建议检查本地网络状况或切换至稍低清晰度，绝大多数情况下不会出现缓冲问题。',
  },
  {
    q: '影片更新频率如何？能找到最新上映的电影吗？',
    a: '我们的内容团队每日实时更新片库，院线新片通常在下映后最快3-7天内即可上线高清版本。热播大片、经典佳片、独立电影等多类型影片均有覆盖，新片速递专区让您不再错过任何精彩。',
  },
  {
    q: '支持哪些设备观看？可以在手机上使用吗？',
    a: '无极电影网全面适配桌面端、平板和移动端设备，无需下载任何APP即可在手机浏览器中流畅观影。无论您使用电脑、iPad还是手机，都能获得一致的优质观影体验。',
  },
  {
    q: '影片画质有哪些选择？真的有蓝光吗？',
    a: '我们提供从流畅到蓝光原画的多档画质选择，其中蓝光专区影片均采用原盘压制，画质细腻色彩饱满，配合大屏设备观看效果尤佳。所有画质档位均可根据您的网络状况自由切换。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 border border-secondary-200 mb-4">
            <i className="ri-question-line text-secondary-600 text-sm"></i>
            <span className="text-xs font-medium text-secondary-700 whitespace-nowrap">快速答疑</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-200 max-w-lg mx-auto">
            关于无极电影网，您可能想了解的一切
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-50 pr-4">
                  {faq.q}
                </h3>
                <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-colors ${
                  openIndex === i ? 'bg-primary-500 text-foreground-950' : 'bg-background-200 text-foreground-300'
                }`}>
                  <i className={`text-sm transition-transform duration-200 ${
                    openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                  }`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-100 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}